<template>
    <div class="image-detail">
        <div class="nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'INDEX' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item @click.native="goCarTrain">{{seriesName}}</el-breadcrumb-item>
                <el-breadcrumb-item  @click.native="goImageList">图片</el-breadcrumb-item>
                <el-breadcrumb-item>图片详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="select-car-module">
            <el-select v-model="value" placeholder="请选择" @change="handleSelectModel">
                <el-option
                    :label="'全部车型'"
                    :value="''"
                    class="option-type option-type-all"
                />
                <div v-for="(op, opi) in options" :key="opi">
                    <div class="option-type">{{op.Type}}</div>
                    <el-option
                        v-for="(model, i) in op.ModelArray" 
                        :key="i"
                        :label="model.ModelName"
                        :value="model.ModelId"
                    >
                    </el-option>
                </div>
            </el-select>
            <div class="ask-prise">
                <div v-if="price" class="ask-prise-txt">厂商指导价：{{price}}</div>
                <div 
                    class="ask-prise-btn"
                    :data-key="'seriesId_' + seriesId + '_modelId_' + (modelId | 'null')"
                    @click="goPrise"
                >获取底价</div>
            </div>
        </div>
        <el-tabs ref="el-tab" tab-position="right" v-model="activeTab" @tab-click="handleTabsClick">
            <el-tab-pane
                v-for="(tab, tabIndex) in tabsArr"
                :key="tab"
                :name="tab"
                :disabled="!totalObj[tab] || totalObj[tab] <= 0"
            >
                <div slot="label" class="tab-slot-label">
                    <div class="tab-label-title">{{tab}}</div>
                    <div class="tab-pic-num">{{totalObj[tab] || 0}}张图</div>
                </div>
                <div class="images-player">
                    <div class="large-images-list">
                        <div
                            class="l-img-wrapper"
                            :class="{
                                animation,
                                'remove-bg': !(imgObj[tab].list && imgObj[tab].list.length)
                            }"
                            ref="lImgWrapper"
                        >
                            <div
                                v-for="(img, i) in imgObj[tab].list"
                                :key="i"
                            >
                                <img
                                    alt=""
                                    width="100%"
                                    height="100%"
                                    :src="img.ThumbnailURL"
                                    v-real-src="img.ObjURL"
                                    class="l-img"
                                >
                            </div>
                        </div>
                        <i v-if="!isDisablePrevBtn" class="c-icon l-btn l-prev" @click="handleBtnClk('l', 'prev', tabIndex)">&#xe617;</i>
                        <i v-if="!isDisableNextBtn" class="c-icon l-btn l-next" @click="handleBtnClk('l', 'next', tabIndex)">&#xe618;</i>
                    </div>
                    <div class="small-images-list">
                        <div class="s-img-wrapper" :class="{animation}" ref="sImgWrapper">
                            <div 
                                v-for="(img, i) in imgObj[tab].list"
                                :key="i"
                                class="s-img-item"
                                :class="{'s-img-selected': i ===  imgSelectIndex}"
                                @click="handleSimgClk(i, tabIndex)"
                            >
                                <img
                                    alt=""
                                    src="@/assets/images/bitmap-small.png"
                                    v-real-src="img.ThumbnailURL"
                                    class="s-img"
                                >
                            </div>
                        </div>
                        <i class="c-icon s-btn s-prev" :class="{'s-disable': isDisablePrevBtn}" @click="handleBtnClk('s', 'prev', tabIndex)">&#xe616;</i>
                        <i class="c-icon s-btn s-next" :class="{'s-disable': isDisableNextBtn}" @click="handleBtnClk('s', 'next', tabIndex)">&#xe619;</i>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <c-qrcode position="SINGLE"/>
    </div>
</template>

<script>

/**
* @file 图片详情
* @author v_xiongdingfeng
*/
import {throttle} from 'lodash';
import request from 'http/request';
import URLS from 'http/URLS';
import {
    openUrlInNewTab,
    handleErr
} from 'js/core';
import {sendLog, inSightObserver, inSightObserverDisconnect} from 'js/log';
import {sendUbcLog} from 'js/ubclog';
import mixinLog from '@/mixin/log.js';
import {mapGetters} from 'vuex';
import {on} from 'js/Utils';
import Qrcode from '@/components/qrcode';

export default {
    name: 'imageDetail',
    mixins: [mixinLog],
    components: {
        'c-qrcode': Qrcode
    },
    props: {
        serid: String,
        modelId: String
    },
    data() {
        return {
            options: [],
            value: '',
            activeTab: '外观',
            tabsArr: ['外观', '内饰', '空间', '官方图'],
            imgSelectIndex: 0,
            seriesList: [],
            seriesId: '',
            seriesName: '',
            modelName: '',
            imgObj: {},
            totalObj: {},
            commomReqParams: {

                /* eslint-disable fecs-camelcase */
                scene: null,
                is_bd_app: 1,
                pn: 1,
                rn: 30,
                series_id: '',
                series_name: '',
                tag_name: '',
                model_id: ''

                /* eslint-enable fecs-camelcase */
            },
            reqParams: {},
            getDataTrigger: false,
            prevPn: 0,
            animation: false, // 是否有过渡效果
            askPriceUrl: '', // 仅做打点使用
            ubcOptions: {}
        };
    },
    created() {
        this.initData();
        this.getTotal();
        if (this.prevPn > 0) {
            this.getData(true).then(() => {
                this.getData(true);
            });
        }
        else {
            this.getData().then(() => {
                this.getData();
            });
        }
    },
    mounted() {
        this.selectByIndex(this.imgSelectIndex);
        on(window, 'keydown', this.handleKeyPress);
        // 这个是 el-tabs 组件中切换tab的方法，把它禁掉
        this.$refs['el-tab'].$refs.nav.changeTab = () => {};
    },
    beforeDestroy() {
        inSightObserverDisconnect(['img_detail_top_askprice_show']);
    },
    computed: {
        imgLength() {
            if (this.imgObj[this.activeTab]
                && this.imgObj[this.activeTab].list) {
                return this.imgObj[this.activeTab].list.length;
            }

            return -1; // list数组 不存在
        },
        imgTotal() {
            if (this.totalObj[this.activeTab]) {
                return this.totalObj[this.activeTab];
            }

            return 0;
        },
        price() {
            let result = '';
            if (this.modelId && this.options.length) {
                this.options.find(element => {
                    element.ModelArray.find(el => {
                        if (el.ModelId === this.modelId) {
                            result = el.ManufacturerPrice;
                        }

                    });
                }
                );
            }

            return result;
        },
        isDisableNextBtn(btnType) {
            if (this.prevPn > 0) {
                if (this.imgLength > 0
                    && this.imgTotal > 0
                    && this.prevPn * 30 + this.imgSelectIndex + 1 === this.imgTotal) {

                    return true;
                }
            }
            else {
                if (this.imgLength > 0
                    && this.imgTotal > 0
                    && this.imgTotal === this.imgLength
                    && this.imgSelectIndex + 1 === this.imgTotal) {
                    return true;
                }
            }

            return false;

        },
        isDisablePrevBtn() {
            if (this.prevPn > 0) {
                return false;
            }
            else {
                if (this.imgSelectIndex <= 0) {
                    return true;
                }
            }
            return false;
        },
        ...mapGetters({
            location: 'location'
        })
    },
    watch: {
        imgTotal(n) {
            this.activeTotal = n;
            // 当图片数量<=0,禁用当前tab,选中其他可选tab
            if (!n || n <= 0) {
                this.tabsArr.some((el, index) => {
                    if (this.totalObj[el] > 0) {
                        this.activeTab = el;
                        return true;
                    }
                    else {
                        this.activeTab = '-1';
                    }
                });
            }

        },
        imgSelectIndex(n) {
            if (this.prevPn > 0) {
                if (n < 20) {
                    this.getData(true);
                }
            }

            if (this.imgLength - n < 20) {
                this.getData();
            }

        }
    },
    methods: {
        sendLog(key, data) {
            // 统一加车系id参数
            /* eslint-disable fecs-camelcase */
            sendLog(key, Object.assign({}, {
                serId: this.series_id
            }, data));
            /* eslint-enable fecs-camelcase */
        },
        initData() {
            let {
                sername,
                tab,
                index
            } = this.$route.query;
            this.seriesId = this.serid;
            this.seriesName = sername;
            if (this.modelId) {
                this.modelId = this.modelId === 'other' || this.modelId === '' ? '' : this.modelId;
            }
            // this.modelId = modelid === 'other' || modelid === '' ? '' : modelid;
            // 兼容低版本路由
            if (this.$route.query.serid && !this.serid) {
                this.seriesId = this.$route.query.serid;
                const modelId = this.$route.query.modelid;
                this.modelId = modelId === 'other' || modelId === '' ? '' : modelId;
            }
            if (tab && this.tabsArr.includes(tab)) {
                this.activeTab = tab;
            }

            this.tabsArr.forEach(element => {
                if (!this.imgObj[element]) {
                    this.$set(this.imgObj, element, {});
                }

                /* eslint-disable fecs-camelcase */
                if (!this.reqParams[element]) {
                    this.reqParams[element] = {
                        ...this.commomReqParams,
                        city: this.location.cityName || '',
                        tag_name: element,
                        series_id: this.seriesId,
                        model_id: this.modelId
                    };
                }

                /* eslint-enable fecs-camelcase */
            });

            if (index) {
                index = parseInt(index, 10);

                if (index > 29) {
                    this.prevPn = Math.ceil((index + 1) / 30);
                    this.reqParams[tab].pn = this.prevPn + 1;
                }

                let i = index % 30;

                this.imgSelectIndex = parseInt(i, 10);
            }
            this.observerAskprice();
            this.sendUbcLog(undefined, undefined, true);
        },
        async getData(isPrev = false) {
            if (this.activeTotal
                && this.imgLength
                && this.imgLength > this.activeTotal) {
                return;
            }

            if (this.getDataTrigger) {
                return;
            }

            this.getDataTrigger = true;
            let res = {};

            /* eslint-disable fecs-camelcase */
            try {
                if (isPrev) {
                    if (this.prevPn < 1) {
                        return this.getDataTrigger = false;
                    }

                    res = await request(URLS.GETCARPICLIST, {
                        ...this.reqParams[this.activeTab],
                        model_id: this.modelId,
                        pn: this.prevPn
                    }, {
                        method: 'GET'
                    });
                }
                else {
                    res = await request(URLS.GETCARPICLIST, {
                        ...this.reqParams[this.activeTab],
                        model_id: this.modelId
                    }, {
                        method: 'GET'
                    });
                }

            }
            catch (error) {
                this.getDataTrigger = false;
                return handleErr(error);
            }
            if (!res.Result) {
                return this.getDataTrigger = false;
            }

            let {
                lists,
                pn,
                modelIndex,
                series_ask_price_wise_url,
                model_ask_price_wise_url
            } = res.Result;
            this.askPriceUrl = series_ask_price_wise_url || model_ask_price_wise_url;
            if (lists && lists.list) {
                let list = lists.list;
                if (isPrev) {
                    this.prevPn = this.prevPn - 1;
                    this.formatAndUpdataImgData({
                        list
                    }, isPrev);
                }
                else {

                    pn = pn + 1;
                    this.updataReqParams({pn});
                    this.formatAndUpdataImgData({
                        list
                    });
                }
            }

            /* eslint-enable fecs-camelcase */
            if (modelIndex && modelIndex.length && !this.options.length) {
                this.options = modelIndex[0].HorseModelArray;
                let t = [];
                this.options.forEach(e => {
                    e.ModelArray.forEach(x => {
                        t.push(x.ModelId);
                    });
                });

                this.value = t.includes(this.modelId) ? this.modelId : '其它车型';
            }

            this.getDataTrigger = false;
        },
        getTotal() {

            /* eslint-disable fecs-camelcase */
            let res = {};
            this.tabsArr.forEach(async element => {
                try {
                    res = await request(URLS.GETCARPICLIST, {
                        ...this.commomReqParams,
                        city: this.location.cityName || '',
                        tag_name: element,
                        series_id: this.seriesId,
                        model_id: this.modelId,
                        pn: 1
                    }, {
                        method: 'GET'
                    });

                }
                catch (error) {
                    return handleErr(error);
                }
                this.$set(this.totalObj, element, parseInt(res.Result.total, 10));
            });

            /* eslint-enable fecs-camelcase */
        },
        updataReqParams(param) {

            /* eslint-disable fecs-camelcase */
            let {pn} = param;
            this.reqParams[this.activeTab].pn = pn;

            /* eslint-enable fecs-camelcase */
        },
        formatAndUpdataImgData(param, isPrev) {
            let {list} = param;
            if (isPrev) {
                if (this.imgLength > 0) {
                    let tmp = this.imgObj[this.activeTab].list;
                    list.push(...tmp);
                    this.$set(this.imgObj[this.activeTab], 'list', list);
                    this.imgSelectIndex += 30;
                    this.selectByIndex(this.imgSelectIndex);
                    this.$nextTick(() => {
                        this.animation = true;
                    });
                }
                else {
                    let tmp = [];
                    tmp.push(...list);
                    this.$set(this.imgObj[this.activeTab], 'list', tmp);
                    if (this.imgSelectIndex > this.imgLength - 1) {
                        this.imgSelectIndex = this.imgLength - 1;
                    }

                    // this.selectByIndex(this.imgSelectIndex);
                }
            }
            else {
                if (this.imgLength > 0) {
                    let tmp = this.imgObj[this.activeTab].list;

                    tmp.push(...list);
                    this.$set(this.imgObj[this.activeTab], 'list', tmp);
                    this.selectByIndex(this.imgSelectIndex);
                }
                else {
                    let tmp = [];
                    tmp.push(...list);
                    this.$set(this.imgObj[this.activeTab], 'list', tmp);
                    this.selectByIndex(this.imgSelectIndex);
                    this.animation = true;
                }
            }
        },
        handleTabsClick() {
            //  切换tab,图片选中初始化为第一张
            this.imgSelectIndex = 0;
            this.prevPn = 0;
            this.selectByIndex(this.imgSelectIndex);
            this.getData();
            this.sendLog('img_detail_tab_click', {
                index: this.tabsArr.indexOf(this.activeTab),
                name: this.activeTab,
                seriesId: this.seriesId
            });
        },
        handleSimgClk(index, tabIndex) {
            this.imgSelectIndex = index;
            this.sImgMove(index, tabIndex);
            this.lImgMove(index, tabIndex);
            this.sendLog('img_detail_thumbnail_click', {
                index: index,
                tag: this.activeTab,
                seriesId: this.seriesId
            });
        },
        sImgMove(index, tabIndex) {
            const imgWidth = 139;
            const imgWrapperWidth = 912;
            const imgWrapperPadding = 39;
            let long = this.imgLength === -1 ? this.commomReqParams.rn : this.imgLength;
            let rest = parseInt(imgWrapperWidth / 2 / imgWidth, 10); // 3
            let small = this.$refs.sImgWrapper[tabIndex];
            let exp = index * imgWidth + imgWrapperPadding - imgWrapperWidth / 2 + imgWidth / 2;
            if (long - index > rest) {

                small.style.transform = `translateX(-${exp < 0 ? 0 : exp}px)`;
            }
            else {
                small.style.transform = `translateX(-${
                long * imgWidth - imgWrapperWidth + imgWrapperPadding * 2
                }px)`;
            }
        },
        lImgMove(index, tabIndex) {
            const imgWrapperWidth = 912;
            let large = this.$refs.lImgWrapper[tabIndex];
            large.style.transform = `translateX(-${index * imgWrapperWidth}px)`;

        },
        handleBtnClk: throttle(function (img, btn, tabIndex, type) {
            if (img === 's') {
                btn === 'prev' && (this.imgSelectIndex -= 3);
                btn === 'next' && (this.imgSelectIndex += 3);
                this.imgSelectIndex <= 0 && (this.imgSelectIndex = 0);
                this.imgSelectIndex >= this.imgLength && (this.imgSelectIndex = this.imgLength - 1);
                this.sImgMove(this.imgSelectIndex, tabIndex);
                this.lImgMove(this.imgSelectIndex, tabIndex);
                this.sendLog('img_detail_thumbnail_btn_click', {
                    btn,
                    index: this.imgSelectIndex
                });
            }
            else if (img === 'l') {
                btn === 'prev' && (this.imgSelectIndex -= 1);
                btn === 'next' && (this.imgSelectIndex += 1);
                this.imgSelectIndex <= 0 && (this.imgSelectIndex = 0);
                this.imgSelectIndex >= this.imgLength && (this.imgSelectIndex = this.imgLength - 1);
                this.sImgMove(this.imgSelectIndex, tabIndex);
                this.lImgMove(this.imgSelectIndex, tabIndex);
                this.sendLog('img_detail_large_btn_click', {
                    btn,
                    index: this.imgSelectIndex,
                    type: type || 'mouse'
                });
            }

        }, 100),
        handleSelectModel() {
            this.sendLog('img_detail_model_select');
            this.$router.push({
                name: 'IMAGE_DETAIL',
                params: {
                    serid: this.serid,
                    modelId: this.value || undefined
                },
                query: this.$route.query
            });

            // /* eslint-disable fecs-camelcase */
            // // 切换下拉菜单，初始化数据
            // this.imgSelectIndex = 0;
            // this.prevPn = 0;
            // this.selectByIndex(this.imgSelectIndex);
            // if (this.activeTab === '-1') {
            //     this.activeTab = '外观';
            // }

            // this.modelId = this.value;
            // this.tabsArr.forEach(element => {
            //     this.$set(this.imgObj[element], 'list', []);
            //     this.reqParams[element].pn = 1;
            //     this.reqParams[element].model_id = this.modelId;

            // });

            // /* eslint-enable fecs-camelcase */

            // this.getTotal();
            // this.getData();

            // this.observerAskprice();
        },
        selectByIndex(index) {
            // 选中当前激活tab下的索引为index的图片
            let tabIndex = this.tabsArr.indexOf(this.activeTab);
            this.imgSelectIndex = index;
            this.sImgMove(index, tabIndex);
            this.lImgMove(index, tabIndex);
        },
        goImageList() {
            this.$router.push(
                {
                    name: 'IMAGE_LIST',
                    query: {
                        sername: this.seriesName,
                        tab: this.activeTab || '外观'
                    },
                    params: {
                        serid: this.seriesId,
                        modeId: this.modelId
                    }
                }
            );
        },
        goCarTrain() {
            this.$router.push(
                {
                    name: 'CAR_TRAIN',
                    query: {
                        seriesName: this.seriesName
                    },
                    params: {
                        serid: this.seriesId
                    }
                }
            );
        },
        goPrise() {
            /* eslint-disable fecs-camelcase */
            this.sendLog('img_detail_ask_price', {
                id: this.modelId,
                seriesId: this.seriesId,
                price_url: this.askPriceUrl
            });
            this.sendUbcLog('clue_form', {ext: {area: 'img_detail_ask_price'}});
            /* eslint-enable fecs-camelcase */
            openUrlInNewTab({
                name: 'ASK_PRICE',
                query: {
                    modelId: this.modelId,
                    fromPage: `${this.$route.path}@img_detail_ask_price`
                },
                params: {
                    serid: this.seriesId
                }
            });

        },
        handleKeyPress(e) {
            // 按下了左键
            if (e.keyCode === 37) {
                this.handleBtnClk('l', 'prev', this.tabsArr.indexOf(this.activeTab), 'keyborad');
            }
            // 按下了右键
            else if (e.keyCode === 39) {
                this.handleBtnClk('l', 'next', this.tabsArr.indexOf(this.activeTab), 'keyborad');
            }
            // 按下了上键
            else if (e.keyCode === 38) {}
            // 按下了下键
            else if (e.keyCode === 40) {}
        },
        observerAskprice() {
            inSightObserverDisconnect(['img_detail_top_askprice_show']);
            this.$nextTick(() => {
                inSightObserver(
                    '.ask-prise-btn',
                    'img_detail_top_askprice_show',
                    {
                        seriesId: this.seriesId,
                        seriesName: this.seriesName,
                        modelId: this.modelId
                    },
                    undefined,
                    {
                        log: true,
                        name: 'clue_form',
                        id: '11435',
                        options: {
                            ext: {
                                /* eslint-disable fecs-camelcase */
                                ...(this.ubcOptions.ext || {}),
                                area: 'img_detail_ask_price',
                                type_id: this.modelId
                                /* eslint-enable fecs-camelcase */
                            },
                            type: 'show',
                            page: '/view/imageDetail'
                        }
                    }
                );
            });
        },
        sendUbcLog(name, options = {}, seriesInfo) {
            /* eslint-disable fecs-camelcase */
            if (seriesInfo) {
                this.ubcOptions = {
                    page: '/view/imageDetail',
                    ext: {
                        client: 'pc',
                        city: this.location.cityName,
                        train_id: this.serid,
                        train_name: this.seriesName,
                        ...(options.ext || {})
                    }
                };
                return;
            }
            const ext = {
                ...(this.ubcOptions.ext || {}),
                ...(options.ext || {}),
                city: this.location.cityName,
                type_id: this.modelId
            };
            sessionStorage.setItem('YOUJIA_SESSION_ASK_PRICE_BTN', JSON.stringify(ext));
            sendUbcLog('11435', 'event', {
                value: name,
                type: options.type || 'clk',
                ...this.ubcOptions,
                ...options,
                ext
            });
            /* eslint-enable fecs-camelcase */
        }
    }
};
</script>

<style scoped lang="less">
@themeColor: #00CECF;

.image-detail {
    margin-top: 30px;
    font-family: PingFang-SC-Regular;
}
.nav {
    margin-bottom: 36px;
    .el-breadcrumb {
        font-size: 16px;
    }
    /deep/ .el-breadcrumb__item {
        cursor: pointer;
        .el-breadcrumb__inner {
            color: #333;
            &.is-link {
                font-weight: 400;
            }
            &:hover {
                color: #333;
            }
        }
        &[aria-current="page"] .el-breadcrumb__inner {
            color: #333;
            cursor: default!important;
            &:hover {
                color: #333;
            }
        }
    }
}
.select-car-module {
    display: flex;
    margin-bottom: 30px;
    .el-select {
        width: 360px;
        /deep/ .el-input.el-input--suffix.is-focus .el-input__inner {
            border-color: @themeColor;
        }
        /deep/ .el-input__inner:focus {
            border-color: @themeColor;
        }
    }
}
.ask-prise {
    display: flex;
    font-size: 16px;
    align-items: center;
    .ask-prise-txt {
        margin-left: 24px;
    }
    .ask-prise-btn {
        width: 100px;
        height: 40px;
        margin-left: 24px;
        font-size: 18px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        border-radius: 4px;
        background-color: @themeColor;
        cursor: pointer;
        user-select: none;
    }
}
// tab样式
.el-tabs.el-tabs--right {
    /deep/ .el-tabs__header {
        float: left;
        margin-left: 0;
        .el-tabs__nav-wrap {
            padding: 1px;
        }
        .el-tabs__nav-wrap::after {
            background-color: transparent;
        }
        .el-tabs__active-bar {
            width: 4px;
            background-color: @themeColor;
        }
        .el-tabs__nav {
            border: 1px solid #eee;
            border-bottom: none;
        }
        .el-tabs__item {
            width: 118px;
            height: 80px;
            padding: 0;
            text-align: center;
            background-color: #f8f8f8;
            box-shadow: 0 -1px #eee inset;
            &.is-active {
                color: @themeColor;
                background-color: #fff;
            }
            &:hover {
                color: @themeColor;
            }
            &.is-disabled {
                user-select: none;
                &:hover {
                    color: #c0c4cc;
                }
            }
        }
        .tab-slot-label {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;

            align-items: center;
            justify-content: center;
        }
        .tab-label-title {
            margin-bottom: 10px;
            font-size: 20px;
            line-height: 20px;
        }
        .tab-pic-num {
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
        }
    }
    /deep/ .el-tabs__content {
        padding: 1px;
    }
}

.images-player {
    width: 912px;
    margin-left: 24px;
    user-select: none;
}
.large-images-list {
    position: relative;
    overflow: hidden;
    width: 912px;
    height: 608px;
    margin-bottom: 20px;
    box-shadow: 0 0 0 1px #eee;
    &:hover .l-btn {
        opacity: .7!important;
    }
    .l-img-wrapper {
        width: 100%;
        height: 100%;
        white-space: nowrap;
        transform: translateX(0px);
        &.animation {
            transition: all .3s ease 0s;
        }
        &.remove-bg {
            background-color: #f8f8f8;
            background-image: url(~assets/images/bitmap-big.png);
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100%;
        }
        > div {
            position: relative;
            display: inline-block;
            width: 100%;
            height: 100%;
        }
    }
    .l-img {
        object-fit: contain;
    }
    .l-btn {
        position: absolute;
        display: flex;
        width: 60px;
        height: 90px;
        font-size: 30px;
        line-height: 30px;
        opacity: 0;
        color: #fff;
        border-radius: .5px;
        background-color: #000;
        transition: all .5s;
        cursor: pointer;

        align-items: center;
        justify-content: center;
        &:hover {
            opacity: .7;
        }
    }
    .l-prev {
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
    .l-next {
        top: 50%;
        right: 0;
        transform: translateY(-50%);
    }
}
.small-images-list {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 98px;
    padding: 0 39px;
    background-color: #f8f8f8;
    box-shadow: 0 0 0 1px #eee;
    .s-img-wrapper {
        width: 100%;
        height: 100%;
        white-space: nowrap;
        transform: translateX(0px);
        &.animation {
            transition: all .3s ease 0s;
        }
    }
    .s-img-item {
        position: relative;
        display: inline-block;
        overflow: hidden;
        width: 135px;
        height: 90px;
        margin: 4px 2px;
        cursor: pointer;
        &.s-img-selected {
            border: 3px solid @themeColor;
            .s-img {
                transform: scale(1.071);
            }
        }
        .s-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    .s-btn {
        position: absolute;
        display: flex;
        width: 39px;
        height: 100%;
        font-size: 18px;
        line-height: 18px;
        background: #fff;
        cursor: pointer;

        align-items: center;
        justify-content: center;
    }
    .s-prev {
        top: 0;
        left: 0;
    }
    .s-next {
        top: 0;
        right: 0;
    }
    .s-disable {
        color: #ccc!important;
    }
}
.option-type {
    height: 28px;
    padding: 0 20px;
    font-size: 14px;
    line-height: 28px;
    background-color: #f00;
    background-color: rgba(241, 241, 241);

    &.option-type-all {
        height: 34px;
        line-height: 34px;
        background-color: #fff;
    }
}
.el-select-dropdown {
    .el-select-dropdown__item.selected {
        color: @themeColor!important;
    }
    .el-select-dropdown__item.option-type.option-type-all:hover {
        background-color: #F5F7FA;
    }
}
</style>